module.exports = __webpack_public_path__ + "img/img_analyist_peng.88c49137.png";